<template>
  <GmapMap
    ref="mapRef"
    :center="getCenter()"
    :zoom="8"
    :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true,
      disableDefaultUi: true,
    }"
    map-type-id="terrain"
    style="width: 100%; height: 700px"
  >
    <div v-for="remito of remitos" :key="remito.id">
      >
      <GmapMarker
        v-if="remito.subClient.latitudAddress != null && remito.subClient.longitudAddress != null"
        :position="getPosition(remito.subClient.latitudAddress, remito.subClient.longitudAddress)"
        :icon="getIcon(remito)"
      >
      </GmapMarker>
      <!-- 
      <GmapInfoWindow>
        <div style="padding:5px">
          <span class="fs-15">{{ 12 }}</span>
        </div>
      </GmapInfoWindow> -->
    </div>
    <!--  <GmapMarker
      v-if="driver.latitud != null && driver.longitud != null"
      :position="getPosition(driver.latitud, driver.longitud)"
      :icon="require('@/assets/images/marker-truck.png')"
    >
    </GmapMarker> -->
  </GmapMap>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  name: "GeoMultipleMarkers",

  components: {},
  props: {
    remitos: Array,
    remitos_seleccionados: Array,
  },
  data() {
    return {
      lngMin: null,
      latMin: null,
      lngMax: null,
      latMax: null,
      drawingManager: null,
      currentPolygon: null,
    };
  },
  computed: {
    google: gmapApi,
    remitosObject() {
      return this.remitos;
    },
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.initDrawingManager(map);
    });
  },
  methods: {
    initDrawingManager(map) {
      const google = this.google;
      if (!google) return;

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.POLYGON,
            google.maps.drawing.OverlayType.RECTANGLE,
          ],
        },
        polygonOptions: {
          fillColor: '#2196F3',
          fillOpacity: 0.3,
          strokeWeight: 2,
          strokeColor: '#1976D2',
          clickable: false,
          editable: true,
          zIndex: 1,
        },
        rectangleOptions: {
          fillColor: '#2196F3',
          fillOpacity: 0.3,
          strokeWeight: 2,
          strokeColor: '#1976D2',
          clickable: false,
          editable: true,
          zIndex: 1,
        },
      });

      this.drawingManager.setMap(map);

      // Escuchar cuando se complete un polígono
      google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
        // Eliminar polígono anterior si existe
        if (this.currentPolygon) {
          this.currentPolygon.setMap(null);
        }

        this.currentPolygon = event.overlay;
        this.drawingManager.setDrawingMode(null);

        // Seleccionar remitos dentro del polígono
        this.selectRemitosInPolygon(event.overlay, event.type);

        // Permitir edición del polígono
        const overlay = event.overlay;
        
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          google.maps.event.addListener(overlay.getPath(), 'set_at', () => {
            this.selectRemitosInPolygon(overlay, event.type);
          });
          google.maps.event.addListener(overlay.getPath(), 'insert_at', () => {
            this.selectRemitosInPolygon(overlay, event.type);
          });
        } else if (event.type === google.maps.drawing.OverlayType.RECTANGLE) {
          google.maps.event.addListener(overlay, 'bounds_changed', () => {
            this.selectRemitosInPolygon(overlay, event.type);
          });
        }
      });
    },
    selectRemitosInPolygon(overlay, type) {
      const google = this.google;
      if (!google) return;

      const remitosEnPoligono = [];

      this.remitos.forEach((remito) => {
        if (remito.subClient.latitudAddress != null && remito.subClient.longitudAddress != null) {
          const position = new google.maps.LatLng(
            parseFloat(remito.subClient.latitudAddress),
            parseFloat(remito.subClient.longitudAddress)
          );

          let isInside = false;

          if (type === google.maps.drawing.OverlayType.POLYGON) {
            isInside = google.maps.geometry.poly.containsLocation(position, overlay);
          } else if (type === google.maps.drawing.OverlayType.RECTANGLE) {
            const bounds = overlay.getBounds();
            isInside = bounds.contains(position);
          }

          if (isInside) {
            remitosEnPoligono.push(remito);
          }
        }
      });

      // Emitir evento al padre con los remitos seleccionados
      this.$emit('remitos-selected', remitosEnPoligono);
    },
    clearPolygon() {
      if (this.currentPolygon) {
        this.currentPolygon.setMap(null);
        this.currentPolygon = null;
      }
      if (this.drawingManager) {
        this.drawingManager.setDrawingMode(null);
      }
    },
    getCenter() {
      // Coordenadas del Obelisco, CABA
      const defaultLat = -34.6037;
      const defaultLng = -58.3816;
      
      if (this.latMax == null || this.latMin == null || this.lngMax == null || this.lngMin == null) {
        return { lat: defaultLat, lng: defaultLng };
      }
      
      var lat = (this.latMax + this.latMin) / 2;
      var lng = (this.lngMax + this.lngMin) / 2;
      return { lat: lat, lng: lng };
    },
    getIcon(remito) {
      if (this.remitos_seleccionados.indexOf(remito) >= 0) {
        return require("@/assets/images/geo/verde.svg");
      } else {
        return require("@/assets/images/geo/rojo.svg");
      }
    },
    getPosition(lat, lng) {
      if (this.latMax == null || this.latMax < parseFloat(lat)) {
        this.latMax = parseFloat(lat);
      }

      if (this.latMin == null || this.latMin > parseFloat(lat)) {
        this.latMin = parseFloat(lat);
      }

      if (this.lngMax == null || this.lngMax < parseFloat(lng)) {
        this.lngMax = parseFloat(lng);
      }

      if (this.lngMin == null || this.lngMin > parseFloat(lng)) {
        this.lngMin = parseFloat(lng);
      }

      this.center = this.getCenter();

      return { lat: parseFloat(lat), lng: parseFloat(lng) };
    },
  },
};
</script>
